"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  cancel: 'Cancel',
  close: 'Close',
  email: 'Email',
  loadMore: 'Load more',
  olapic2Report: 'Report',
  olapic2ReportFailed: 'Something went wrong. Please try again.',
  olapic2ReportPhotoAreYouSure: 'Are you sure you want to report this photo?',
  olapic2ReportPhotoExplanation: 'This means it is inappropriate, has violated some law or infringes someone’s rights. Reporting this photo will automatically remove it from view. Please allow 20 minutes for cache to clear and photo to be removed. Email addresses are stored and processed in the case that we need to provide feedback related to a report. We will not transmit your email address to any third party.',
  olapic2ReportSuccess: 'Media item is successfully reported.',
  olapic2ShareWith: 'Share your amazing looks with @oriflame and #OriflameOnMe',
  oriflameOnMe: '#OriflameOnMe',
  reason: 'Reason',
  reportPhoto: 'Report photo',
  sharePost: 'Share post',
  shopThisLook: 'Shop this look',
  viewAll: 'View all'
};
const translationsNamespace = exports.translationsNamespace = 'olapic';
